export const canShowBySuppressionKey = (
  key: string,
  now: Date = new Date(),
): boolean => {
  if (typeof window === 'undefined') {
    return false;
  }
  const stored = window.localStorage.getItem(key);
  if (!stored) {
    return true;
  }
  const suppressedUntil = new Date(stored);
  if (Number.isNaN(suppressedUntil.getTime())) {
    return true;
  }
  return now >= suppressedUntil;
};

export const suppressBySuppressionKey = (
  key: string,
  days: number,
  now: Date = new Date(),
): void => {
  if (typeof window === 'undefined') {
    return;
  }
  const suppressedUntil = new Date(now);
  suppressedUntil.setDate(suppressedUntil.getDate() + days);
  window.localStorage.setItem(key, suppressedUntil.toISOString());
};
